export default __webpack_public_path__ + "static/media/github.3c2fbcc1.svg";